import React, { useState } from "react";
// Use Forms
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
// React Bootstrap
import { Container, Row, Form, Button, Col, Accordion, Card } from "react-bootstrap";
// Utils
import { tiposEducacionObra } from "../../../../contexto";

const FormEducativos = ({ defaultValues, submissionHandler, ...props }) => {
  const [validated] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues,
  });

  // On submit del formulario
  const onSubmit = (data) => {
    console.log(data)
    submissionHandler(data);
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit(onSubmit)} className="m-3">
      <Form.Row>
        <small className="mb-3">
          Los campos con un <b>*</b> deben de ser rellenados.
        </small>
      </Form.Row>
      <Container fluid>
        <Row xs={1} lg={3}>
          {Object.keys(tiposEducacionObra).map((tipoEducacion) => {
            return (
              <Col>
                <Accordion defaultActiveKey="0" className="mb-2">
                  <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="0">
                      {tiposEducacionObra[tipoEducacion]}
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="0">
                      <Card.Body>
                        <Form.Row>
                          <Form.Group as={Col} xs={12} md controlId={`${tipoEducacion}-maxCap`}>
                            <Form.Label>{"Capacidad máxima"}</Form.Label>
                            <Form.Control
                              name={`${tipoEducacion}.maxCap`}
                              type="number"
                              isInvalid={errors[tipoEducacion] && errors[tipoEducacion].maxNumberM}
                              {...register(`${tipoEducacion}.maxCap`, {
                                min: { value: 0, message: "El campo debe ser mayor o igual que 0" },
                              })}
                            />
                            <ErrorMessage errors={errors} name={`${tipoEducacion}.maxCap`} render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                          </Form.Group>
                        </Form.Row>
                        <Form.Row>
                          <Form.Group as={Col} xs={12} md controlId={`${tipoEducacion}-nPeopleM`}>
                            <Form.Label>{"Nº de varones"}</Form.Label>
                            <Form.Control
                              name={`${tipoEducacion}.nPeopleM`}
                              type="number"
                              isInvalid={errors[tipoEducacion] && errors[tipoEducacion].nPeopleM}
                              {...register(`${tipoEducacion}.nPeopleM`, {
                                min: { value: 0, message: "El campo debe ser mayor o igual que 0" },
                              })}
                            />
                            <ErrorMessage errors={errors} name={`${tipoEducacion}.nPeopleM`} render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                          </Form.Group>
                        </Form.Row>
                        <Form.Row>
                          <Form.Group className={"d-none"}>
                            <Form.Control name={`${tipoEducacion}.type`} value={tipoEducacion} {...register(`${tipoEducacion}.type`, {})} />
                          </Form.Group>
                          <Form.Group as={Col} xs={12} md controlId={`[${tipoEducacion}]-nPeopleF`}>
                            <Form.Label>{"Nº de mujeres"}</Form.Label>
                            <Form.Control
                              isInvalid={errors[tipoEducacion] && errors[tipoEducacion].nPeopleF}
                              name={`${tipoEducacion}.nPeopleF`}
                              type="number"
                              {...register(`${tipoEducacion}.nPeopleF`, {
                                min: { value: 0, message: "El campo debe ser mayor o igual que 0" },
                              })}
                            />
                            <ErrorMessage errors={errors} name={`${tipoEducacion}.nPeopleF`} render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                          </Form.Group>
                        </Form.Row>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </Col>
            );
          })}
        </Row>
      </Container>
      <Form.Group>
        <Button type="submit" variant="outline-primary" className="btn btn-block mt-5">
          Guardar
        </Button>
      </Form.Group>
    </Form>
  );
};

export default FormEducativos;
